import React from 'react';
import { TransitionRoute } from 'components/general/TransitionRoute';
import { EditButton, ConfirmationButton, MinimizeButton } from 'components/general/StandardButtons';
import { Input } from 'antd';
import './TemplateTitle.less';

interface ITemplateTitleProps {
    templateName: string;
    reusableFlag?: boolean;
    onNameChange(newName: string): void;
    noEdit?:boolean;
}
interface ITemplateTitleState {
    templateName: string;
    editingTitle: boolean;
}

export class TemplateTitle extends React.Component<ITemplateTitleProps, ITemplateTitleState>
{
    constructor(props: ITemplateTitleProps) {
        super(props);
        this.state = {
            templateName: props.templateName,
            editingTitle: false,
        };
    }
    componentWillMount = () => {
        this.setState({ templateName: this.props.templateName });
    }
    componentWillReceiveProps = (nextProps: ITemplateTitleProps) => {
        if (this.state.templateName != nextProps.templateName) {
            this.setState({ templateName: nextProps.templateName });
        }
    }
    public editingToggle = () => {
        this.setState({ editingTitle: !this.state.editingTitle });
    }
    public saveNameChange = () => {
        this.editingToggle();
        this.props.onNameChange(this.state.templateName);
    }
    public handleTitleInput = (event: any) => {
        const { value } = event.target;
        this.setState({ templateName: value });
    }
    render() {
        if (this.props.noEdit) {
            return (
                <div className="template-title-wrapper">
                    <h3>{this.props.templateName} Template</h3>
                </div>
            )
        }
        return (
            <div>
                <TransitionRoute on={this.state.editingTitle} case={false}>
                    <div>
                        {this.props.reusableFlag ?
                            <div className="reusable-container">
                                <h3 className="reusable-label">Reusable Template</h3>
								<span>-</span>
                                <h5 className="reusable-warning">Changes to this template could affect many sections</h5>
                            </div>
                            :
                            null
                        }
                        <div className="template-title-wrapper">
                            <h3>{this.props.templateName}</h3>
                            <EditButton onClick={this.editingToggle} />
                        </div>
                    </div>
                </TransitionRoute>
                <TransitionRoute on={this.state.editingTitle} case={true}>
                    <div>
                        {this.props.reusableFlag ?
                            <div className="reusable-container">
                                <h3 className="reusable-label">Reusable Template</h3>
                                <h5 className="reusable-warning">Changes to this template could affect many sections</h5>
                            </div>
                            :
                            null
                        }
                        <div className="template-title-wrapper">
                            <Input type="text" value={this.state.templateName} onChange={this.handleTitleInput} />
                            <ConfirmationButton onClick={this.saveNameChange} />
                            <MinimizeButton onClick={this.editingToggle} />
                        </div>
                    </div>
                </TransitionRoute>
            </div>
        )
    }
}
